import { httpClient } from "../http/httpClient"

export async function uploadProductImage(type: string, image: File) {
  const formData = new FormData()
  formData.append('image', image)
  
  const { data } = await httpClient.patch<{ success: boolean }>(`/config/product/${type}/image`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return data
}